"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4819],{

/***/ 69443:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _mui_material_Box__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61953);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77366);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  cursor: pointer;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}


const CursorBox = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_templateObject());
/* harmony default export */ __webpack_exports__["Z"] = (CursorBox);


/***/ }),

/***/ 46895:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _mui_material_Grid__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(79072);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77366);
/* harmony import */ var _mui_material_useMediaQuery__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(61225);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(62097);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-top: 0;\n  margin-bottom: 0;\n\n  & > .MuiGrid-item {\n    padding-top: 0;\n    padding-bottom: 0;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}






const StyledGrid = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_templateObject());
const GutterGrid = (param)=>{
    let { xs , md , lg , xl , ...rest } = param;
    // const isSM = useMediaQuery({ minWidth: 576, maxWidth: 767 })
    const theme = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)();
    const isMD = (0,_mui_material_useMediaQuery__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(theme.breakpoints.between("md", "lg"));
    const isLG = (0,_mui_material_useMediaQuery__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(theme.breakpoints.between("lg", "xl"));
    const isXL = (0,_mui_material_useMediaQuery__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(theme.breakpoints.up("xl"));
    const defaultSpacing = xs ? 2 : 0;
    const [spacing, setSpacing] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(defaultSpacing);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        if (isMD) {
            md && setSpacing(4);
        } else if (isLG) {
            lg && setSpacing(6);
        } else if (isXL) {
            xl && setSpacing(8);
        } else {
            xs && setSpacing(defaultSpacing);
        }
    }, [
        isMD,
        isLG,
        isXL
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledGrid, {
        container: true,
        spacing: spacing,
        ...rest
    });
};
GutterGrid.defaultProps = {
    xs: true,
    md: true,
    lg: true,
    xl: true
};
/* harmony default export */ __webpack_exports__["Z"] = (GutterGrid);


/***/ }),

/***/ 26643:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77366);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var utils_hooks_dom__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(53258);
/* harmony import */ var use_deep_compare_effect__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87620);
/* harmony import */ var utils_hooks__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(13946);
/* harmony import */ var components_common_ScrollToTopButton__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(98780);
/*
 * 配合react-infinite-scroll-component使用
 * 當需要scrollableTarget時(在element scroll而不是window)
 * 須給定element實際的height pixel
 */ 
function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  overflow-y: hidden;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  height: ",
        "px;\n  overflow-y: auto;\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}








const Container = _emotion_styled__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div */ .Z.div(_templateObject());
const HeightSyncToContainer = _emotion_styled__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div */ .Z.div(_templateObject1(), (props)=>props.height);
const InfiniteContainer = (param)=>{
    let { children , id , containerRef , filterState ={} , ...rest } = param;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    const { page  } = (router === null || router === void 0 ? void 0 : router.query) || {};
    const [node, nodeRef] = (0,utils_hooks_dom__WEBPACK_IMPORTED_MODULE_5__/* .useStateRef */ .Y)();
    const [height, setHeight] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)();
    const scrollableRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    const { showButton , showScrollButton  } = (0,utils_hooks__WEBPACK_IMPORTED_MODULE_7__/* .useShowScrollToTopButton */ .zi)();
    // 判斷當有頁面 query 且改變時為點擊換頁，使頁面置頂
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        if ((router === null || router === void 0 ? void 0 : router.pathname) === "/vender" && page) {
            setTimeout(()=>{
                var _scrollableRef_current;
                return (scrollableRef === null || scrollableRef === void 0 ? void 0 : scrollableRef.current) && (scrollableRef === null || scrollableRef === void 0 ? void 0 : (_scrollableRef_current = scrollableRef.current) === null || _scrollableRef_current === void 0 ? void 0 : _scrollableRef_current.scrollTo({
                    top: 0,
                    behavior: "smooth"
                }));
            }, 0);
        }
    }, [
        page,
        filterState
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        if ((scrollableRef === null || scrollableRef === void 0 ? void 0 : scrollableRef.current) && containerRef) {
            containerRef.current = scrollableRef === null || scrollableRef === void 0 ? void 0 : scrollableRef.current;
        }
    }, [
        scrollableRef === null || scrollableRef === void 0 ? void 0 : scrollableRef.current,
        containerRef
    ]);
    const handleResize = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(()=>{
        if (node) {
            setHeight(node.clientHeight);
        }
    }, [
        node
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        if (!node) {
            return;
        }
        const observer = new ResizeObserver(handleResize);
        observer.observe(node);
        return ()=>{
            observer.unobserve(node);
        };
    }, [
        node,
        handleResize
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Container, {
        ref: nodeRef,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(HeightSyncToContainer, {
            height: height,
            id: id,
            ref: scrollableRef,
            onScroll: showScrollButton,
            children: [
                children,
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_ScrollToTopButton__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    showButton: showButton,
                    scrollableRef: scrollableRef
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (InfiniteContainer);


/***/ }),

/***/ 84070:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var config_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73221);



const NoindexRemoval = (props)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
            children: config_constants__WEBPACK_IMPORTED_MODULE_2__/* .APP_ENV */ .Wi === "prod" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {}, "noindex")
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (NoindexRemoval);


/***/ }),

/***/ 2925:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77366);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-overflow: ellipsis;\n  overflow: hidden;\n  ",
        ";\n  line-height: ",
        ";\n  height: ",
        ";\n  text-align: ",
        ";\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}

const NowrapDiv = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(_templateObject(), (param)=>{
    let { $lines  } = param;
    return !!$lines && $lines > 1 ? "display: -webkit-box;" + "-webkit-line-clamp: ".concat($lines, ";") + "-webkit-box-orient: vertical;" : "white-space: nowrap;";
}, (param)=>{
    let { $fixHeight  } = param;
    return $fixHeight ? "1.2em" : "";
}, (param)=>{
    let { $lines , $fixHeight  } = param;
    return $fixHeight ? ($lines || 1) * 1.2 + "em" : "auto";
}, (param)=>{
    let { $textCenter  } = param;
    return $textCenter ? "center" : "left";
});
/* harmony default export */ __webpack_exports__["Z"] = (NowrapDiv);


/***/ }),

/***/ 92890:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _mui_material_Grid__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(79072);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93021);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(61303);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(20625);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77366);
/* harmony import */ var components_common_A__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79592);
/* harmony import */ var components_common_SVGElements__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(36406);
/* harmony import */ var components_common_SVGElements__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69854);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}






const Button = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject(), (param)=>{
    let { theme , $checked  } = param;
    return "\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n    width: 32px;\n    height: 29px;\n    color: ".concat($checked ? "white" : theme.palette.text.secondary, ";\n    background-color: ").concat($checked ? theme.palette.primary.main : "white", ";\n    border-radius: ").concat(theme.spacing(1), ";\n    border: 1px solid ").concat($checked ? theme.palette.primary.main : "white", ";\n\n    &:hover {\n      border-color: ").concat(theme.palette.text.secondary, ";\n    }\n  ");
});
const Pagination = (param)=>{
    let { page , setPage , pageAmount , urlPath  } = param;
    let startPage = (0,lodash_es__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)([
        [
            (p)=>p === 1,
            ()=>1
        ],
        [
            (p)=>p === 2 || p === 3,
            ()=>2
        ],
        [
            (p)=>p > 3,
            (p)=>p + 2 > pageAmount ? (0,lodash_es__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)([
                    pageAmount - 4,
                    1
                ]) : p - 2
        ],
        [
            ()=>true,
            ()=>1
        ]
    ])(page);
    const length = (0,lodash_es__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)([
        5,
        pageAmount - startPage + 1
    ]);
    const paginations = Array.from({
        length
    }, (_, i)=>i + startPage);
    const onPrevClick = ()=>setPage((0,lodash_es__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)([
            page - 1,
            1
        ]));
    const onNextClick = ()=>setPage((0,lodash_es__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)([
            page + 1,
            pageAmount
        ]));
    const abortLinkClick = (e)=>e.preventDefault();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
            container: true,
            spacing: 1,
            children: [
                page !== 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                            item: true,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_A__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                onClick: abortLinkClick,
                                href: !!urlPath ? "".concat(urlPath, "?page=").concat((0,lodash_es__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)([
                                    page - 1,
                                    1
                                ])) : "",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Button, {
                                    onClick: onPrevClick,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_SVGElements__WEBPACK_IMPORTED_MODULE_8__/* .ArrowLeft */ .X, {
                                        textSecondary: true
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                            item: true,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_A__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                onClick: abortLinkClick,
                                href: !!urlPath ? "".concat(urlPath, "?page=1") : "",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Button, {
                                    onClick: ()=>setPage(1),
                                    children: "1"
                                })
                            })
                        })
                    ]
                }),
                paginations === null || paginations === void 0 ? void 0 : paginations.map((pagination)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                        item: true,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_A__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            onClick: abortLinkClick,
                            href: !!urlPath ? "".concat(urlPath, "?page=").concat(pagination) : "",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Button, {
                                $checked: page === pagination,
                                onClick: ()=>setPage(pagination),
                                children: pagination
                            })
                        })
                    }, "page-".concat(pagination))),
                page < pageAmount && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                    item: true,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_A__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        onClick: abortLinkClick,
                        href: !!urlPath ? "".concat(urlPath, "?page=").concat((0,lodash_es__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)([
                            page + 1,
                            pageAmount
                        ])) : "",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Button, {
                            onClick: onNextClick,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_SVGElements__WEBPACK_IMPORTED_MODULE_9__/* .ArrowRight */ .o, {
                                textSecondary: true
                            })
                        })
                    })
                })
            ]
        })
    });
};
Pagination.defaultProps = {
    page: 1,
    pageAmount: 1
};
/* harmony default export */ __webpack_exports__["Z"] = (Pagination);


/***/ }),

/***/ 36406:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ ArrowLeft; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _SVG__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54806);


const ArrowLeft = (props)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SVG__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        xmlns: "http://www.w3.org/2000/sv g",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
            className: "arrow_left_24",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                d: "M15.707 5.293a1 1 0 010 1.414L10.414 12l5.293 5.293a1 1 0 01-1.414 1.414l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 0z",
                className: "Vector (Stroke)",
                clipRule: "evenodd"
            })
        })
    });
};


/***/ }),

/***/ 69854:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ ArrowRight; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _SVG__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54806);


const ArrowRight = (param)=>{
    let { color , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SVG__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        $color: color,
        ...props,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
            className: "arrow_right_24l",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                d: "M8.293 5.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L13.586 12 8.293 6.707a1 1 0 010-1.414z",
                className: "Vector (Stroke)",
                clipRule: "evenodd"
            })
        })
    });
};


/***/ }),

/***/ 2982:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ ClearSVG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _SVG__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54806);


const ClearSVG = (props)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_SVG__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M8.0026 14.6654C11.6845 14.6654 14.6693 11.6806 14.6693 7.9987C14.6693 4.3168 11.6845 1.33203 8.0026 1.33203C4.32071 1.33203 1.33594 4.3168 1.33594 7.9987C1.33594 11.6806 4.32071 14.6654 8.0026 14.6654Z",
                fill: "#BDBDBD",
                ...props
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M10.7071 6.70711C11.0976 6.31658 11.0976 5.68342 10.7071 5.29289C10.3166 4.90237 9.68342 4.90237 9.29289 5.29289L8 6.58579L6.70711 5.29289C6.31658 4.90237 5.68342 4.90237 5.29289 5.29289C4.90237 5.68342 4.90237 6.31658 5.29289 6.70711L6.58579 8L5.29289 9.29289C4.90237 9.68342 4.90237 10.3166 5.29289 10.7071C5.68342 11.0976 6.31658 11.0976 6.70711 10.7071L8 9.41421L9.29289 10.7071C9.68342 11.0976 10.3166 11.0976 10.7071 10.7071C11.0976 10.3166 11.0976 9.68342 10.7071 9.29289L9.41421 8L10.7071 6.70711Z",
                fill: "white"
            })
        ]
    });
};


/***/ }),

/***/ 71908:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ CloseSVG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _SVG__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54806);


const CloseSVG = (props)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SVG__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        xmlns: "http://www.w3.org/2000/svg",
        width: props.width || 24,
        height: props.height || 24,
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
            className: "btn_close_24",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                d: "M18.707 6.707a1 1 0 00-1.414-1.414L12 10.586 6.707 5.293a1 1 0 00-1.414 1.414L10.586 12l-5.293 5.293a1 1 0 101.414 1.414L12 13.414l5.293 5.293a1 1 0 001.414-1.414L13.414 12l5.293-5.293z",
                className: "Union",
                clipRule: "evenodd"
            })
        })
    });
};


/***/ }),

/***/ 66212:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ SearchSVG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _SVG__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54806);


const SearchSVG = (param)=>{
    let { color , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SVG__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
            className: "search",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: color,
                fillRule: "evenodd",
                d: "M4 11a7 7 0 1112.041 4.857 1.005 1.005 0 00-.184.184A7 7 0 014 11zm12.618 7.032a9 9 0 111.414-1.414l3.675 3.675a1 1 0 11-1.414 1.414l-3.675-3.675z",
                className: "Union",
                clipRule: "evenodd"
            })
        })
    });
};


/***/ }),

/***/ 78327:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _mui_material_Select__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46541);
/* harmony import */ var _mui_icons_material_ExpandMore__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23508);
/* harmony import */ var _mui_icons_material_ArrowDropDown__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45111);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93021);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77366);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}






const StyledSelect = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_mui_material_Select__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_templateObject(), (param)=>{
    let { theme , disabled , $hasSelection , $size , $color  } = param;
    return "\n    font-size: ".concat($size === "large" ? theme.typography.body1.fontSize : $size === "medium" ? "16px" : $size === "small" ? "14px" : theme.typography.h6.fontSize, ";\n\n    &::before, &::after {\n      border-bottom: none !important;\n    }\n\n    #selector {\n      padding-left: 10px;\n      &:focus {\n        background-color: initial;\n      }\n    }\n\n    #service-info {\n      ").concat(disabled ? "background-color: ".concat(theme.palette.background.gray) : "", ";\n    }\n\n    color: ").concat((0,lodash_es__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)([
        [
            ()=>disabled && $hasSelection,
            ()=>theme.palette.text.minus2
        ],
        [
            ()=>disabled && !$hasSelection,
            ()=>theme.palette.text.secondary
        ],
        [
            ()=>$hasSelection,
            ()=>$color === "primary" ? theme.palette.primary.main : theme.palette.text.minus2
        ],
        [
            ()=>true,
            ()=>theme.palette.text.secondary
        ]
    ])(), ";\n    ").concat(disabled ? "background-color: ".concat(theme.palette.background.gray) : "", ';\n    div[role="button"] {\n      ').concat($size === "medium" ? "padding: 12px ".concat($hasSelection ? "32px" : "16px", " 12px 15px;") : "", "\n      ").concat($size === "small" ? "padding: 10px ".concat($hasSelection ? "32px" : "16px", " 10px 10px;") : "", "\n    }\n    ").concat($size === "medium" ? "#selector { padding: 12px ".concat($hasSelection ? "32px" : "16px", " 12px 15px; }") : "", "\n    ").concat($size === "small" ? "#selector { padding: 10px ".concat($hasSelection ? "32px" : "16px", " 10px 10px; }") : "", "\n  ");
});
const StyledExpandMoreIcon = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_mui_icons_material_ExpandMore__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_templateObject1(), (param)=>{
    let { theme  } = param;
    return "\n    fill: ".concat(theme.palette.text.disabled, ";\n  ");
});
const MainTextExpandMoreIcon = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_mui_icons_material_ExpandMore__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_templateObject2(), (param)=>{
    let { theme  } = param;
    return "\n    padding-right:8px;\n    fill: ".concat(theme.palette.text.primary, ";\n  ");
});
const StyledArrowDropDownIcon = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_mui_icons_material_ArrowDropDown__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_templateObject3(), (param)=>{
    let { theme  } = param;
    return "\n    padding-right:8px;\n    fill: ".concat(theme.palette.text.disabled, ";\n  ");
});
const chooseIconByColor = function(color) {
    let size = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "medium";
    if (size === "small") {
        return StyledArrowDropDownIcon;
    }
    if (color === "textPrimary") {
        return MainTextExpandMoreIcon;
    }
    return StyledExpandMoreIcon;
};
const Select = (param)=>{
    let { label , value , onChange , disabled , IconComponent , size , color , iconColor , children , muiLabel , labelId , ...rest } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledSelect, {
        value: value,
        onChange: onChange,
        disabled: disabled,
        label: muiLabel,
        labelId: labelId,
        $hasSelection: !!value || value === 0 || value === false,
        $size: size,
        $color: color,
        ...rest,
        inputProps: {
            id: "selector"
        },
        IconComponent: IconComponent || chooseIconByColor(iconColor, size),
        children: [
            !!(rest === null || rest === void 0 ? void 0 : rest.native) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("option", {
                value: "",
                disabled: true,
                children: label
            }),
            children
        ]
    });
};
Select.defaultProps = {
    native: true,
    value: "",
    size: "default",
    color: "primary"
};
/* harmony default export */ __webpack_exports__["Z"] = (Select);


/***/ }),

/***/ 85459:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _mui_material_Box__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(61953);
/* harmony import */ var _mui_material_Typography__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(29630);
/* harmony import */ var _mui_material_InputBase__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(81011);
/* harmony import */ var _mui_material_Paper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70918);
/* harmony import */ var components_common_SVGElements__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(71908);
/* harmony import */ var components_common_SVGElements__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(66212);
/* harmony import */ var components_common_SVGElements__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(2982);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77366);
/* harmony import */ var config_theme__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26059);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  max-height: calc(100vh - ",
        ");\n  overflow-y: auto;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  text-decoration: ",
        ";\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex: 1;\n  font-size: 16px;\n  color: ",
        ";\n  margin-left: ",
        ";\n\n  & .MuiInputBase-input {\n    padding: 0;\n    ::placeholder {\n      color: ",
        ";\n      opacity: 1;\n    }\n  }\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: sticky;\n  top: 0px;\n  z-index: 10;\n  background-color: white;\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}









// import {
//   useAdvancedFilterItems,
//   useServiceClassification,
// } from 'utils/api/hooks'
// import TextCheckboxButton from './TextCheckboxButton'
// import TextField from 'components/common/TextField'
// import Divider from '@mui/material/Divider'
// import FormControl from '@mui/material/FormControl'
// import { debounce, isNumber } from 'lodash-es'
const Wrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div */ .Z.div(_templateObject(), config_theme__WEBPACK_IMPORTED_MODULE_4__/* .headerHeight */ .J9);
const ClearText = _emotion_styled__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div */ .Z.div(_templateObject1(), (param)=>{
    let { theme  } = param;
    return "\n    font-size: 1rem;\n    cursor: pointer;\n    color: ".concat(theme.palette.text.primary, ";\n  ");
}, (param)=>{
    let { isLarge  } = param;
    return isLarge ? "underline" : "none";
});
const InputPaper = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_mui_material_Paper__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_templateObject2(), (param)=>{
    let { theme  } = param;
    return "\n    padding: 12px 15px;\n    display: flex;\n    align-items: center;\n    flex: 1;\n    border-color: ".concat(theme.palette.background.line, ";\n  ");
});
const SearchInput = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_mui_material_InputBase__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_templateObject3(), (param)=>{
    let { theme  } = param;
    return theme.palette.primary.main;
}, (param)=>{
    let { theme  } = param;
    return theme.spacing(2);
}, (param)=>{
    let { theme  } = param;
    return theme.palette.text.secondary;
});
const Sticky = _emotion_styled__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div */ .Z.div(_templateObject4());
const AdvanceFilters = (param)=>{
    let { serviceClassificationName , onRemoveFilteredName , dispatch , isLarge , onClose , onSubmitNameInput , isVisible  } = param;
    /* 進階篩選-服務方案 */ // const { data: filterItemInfos } = useAdvancedFilterItems(() =>
    //   serviceClassification ? { serviceClassification, limit: 200 } : null
    // )
    // const { data: classification } = useServiceClassification(
    //   serviceClassification
    // )
    // const filterItemSet = useMemo(() => {
    //   return new Set(advancedFilterItems || [])
    // }, [advancedFilterItems])
    // const onAdvancedFilterItemToggle = (item) => {
    //   dispatch({ type: 'TOGGLE_ADVANCED_FILTER_ITEM', payload: item._id })
    // }
    // const [budgetText, setBudgetText] = useState(
    //   (state.customerBudget || '').toString()
    // )
    // const debounceDispatch = useCallback(debounce(dispatch, 500), [dispatch])
    // const onCustomerBudgetChange = (e) => {
    //   setBudgetText(e.target.value)
    //   debounceDispatch({ type: 'SET_CUSTOMER_BUDGET', payload: e.target.value })
    // }
    // useEffect(() => {
    //   if (isNumber(state.customerBudget))
    //     setBudgetText(state.customerBudget.toString())
    //   if (!isNumber(state.customerBudget) && budgetText?.length) {
    //     setBudgetText('')
    //   }
    // }, [state.customerBudget])
    const [nameInput, setNameInput] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(serviceClassificationName || "");
    const onNameChange = (e)=>{
        setNameInput(e.target.value);
    };
    const clearNameInput = ()=>setNameInput("");
    const onSubmit = ()=>{
        dispatch({
            type: "SET_FILTER_NAME",
            payload: nameInput
        });
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        if (serviceClassificationName !== nameInput) {
            setNameInput(serviceClassificationName || "");
        }
    }, [
        serviceClassificationName
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        if (onSubmitNameInput) {
            onSubmitNameInput(nameInput);
        }
    }, [
        nameInput
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Sticky, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    display: "flex",
                    justifyContent: "space-between",
                    mt: isLarge && isVisible ? 6 : 0,
                    children: [
                        !isLarge ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_SVGElements__WEBPACK_IMPORTED_MODULE_8__/* .CloseSVG */ .b, {
                            onClick: onClose,
                            sx: {
                                cursor: "pointer"
                            }
                        }) : null,
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                            variant: "titleLarge",
                            mb: 6,
                            children: "篩選"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ClearText, {
                            onClick: onRemoveFilteredName,
                            isLarge: isLarge,
                            children: "清除"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                variant: "paraTitleSmall",
                mb: 4,
                children: "廠商關鍵字"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(InputPaper, {
                variant: "outlined",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_SVGElements__WEBPACK_IMPORTED_MODULE_10__/* .SearchSVG */ .M, {
                        color: "#9B9B9B"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SearchInput, {
                        sx: {
                            typography: "bodyMedium"
                        },
                        placeholder: "請輸入廠商關鍵字",
                        value: nameInput,
                        inputProps: {
                            maxLength: 256
                        },
                        onChange: onNameChange,
                        onKeyPress: (e)=>{
                            if (e.key === "Enter") onSubmit();
                        }
                    }),
                    nameInput && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        display: "flex",
                        alignItems: "center",
                        px: 1,
                        onClick: clearNameInput,
                        sx: {
                            cursor: "pointer"
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_SVGElements__WEBPACK_IMPORTED_MODULE_11__/* .ClearSVG */ .A, {})
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (AdvanceFilters);


/***/ }),

/***/ 7676:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ VENDER_AD_WARNING_TEXT; }
/* harmony export */ });
const VENDER_AD_WARNING_TEXT = "本網頁/APP廣告頁僅提供廠商預約相關服務刊登廣告，相關廣告文宣及其商品或服務均由廠商自行提供，與信義房屋/信義居家無涉，信義房屋/信義居家無法擔保廠商廣告內容的正確性、可信度或即時性，亦不為其商品、服務品質負責，所生任何爭議皆請自行與廠商協調解決。";


/***/ }),

/***/ 94819:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ vender; },
  "getServerSidePropsFunction": function() { return /* binding */ getServerSidePropsFunction; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/ua-parser-js/src/ua-parser.js
var ua_parser = __webpack_require__(42238);
var ua_parser_default = /*#__PURE__*/__webpack_require__.n(ua_parser);
// EXTERNAL MODULE: ./node_modules/lodash-es/includes.js + 2 modules
var includes = __webpack_require__(19658);
// EXTERNAL MODULE: ./node_modules/lodash-es/max.js + 1 modules
var max = __webpack_require__(61303);
// EXTERNAL MODULE: ./node_modules/lodash-es/cond.js
var cond = __webpack_require__(93021);
// EXTERNAL MODULE: ./utils/withLivingSinyi.js + 8 modules
var withLivingSinyi = __webpack_require__(93756);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/use-deep-compare-effect/dist/use-deep-compare-effect.esm.js + 1 modules
var use_deep_compare_effect_esm = __webpack_require__(87620);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(89289);
// EXTERNAL MODULE: ./node_modules/lodash-es/isNumber.js
var isNumber = __webpack_require__(290);
// EXTERNAL MODULE: ./node_modules/lodash-es/flatten.js
var flatten = __webpack_require__(27961);
// EXTERNAL MODULE: ./node_modules/lodash-es/sortBy.js
var sortBy = __webpack_require__(98697);
// EXTERNAL MODULE: ./node_modules/lodash-es/isString.js
var isString = __webpack_require__(36378);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/useTheme.js
var useTheme = __webpack_require__(62097);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(61225);
// EXTERNAL MODULE: ./node_modules/react-infinite-scroll-component/dist/index.es.js
var index_es = __webpack_require__(58533);
// EXTERNAL MODULE: ./node_modules/react-lazyload/lib/index.js
var lib = __webpack_require__(1216);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Box/Box.js + 1 modules
var Box = __webpack_require__(61953);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(29630);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(79072);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 3 modules
var emotion_styled_browser_esm = __webpack_require__(77366);
;// CONCATENATED MODULE: ./utils/hooks/useMeasureHeight.js
/**
 測量 DOM 元素的高度，在元素高度變化時自動更新。
 返回 setter 函數來綁定目標 DOM，以及實時更新的高度值。
 */ 
const useMeasureHeight = ()=>{
    const [height, setHeight] = (0,react.useState)(0);
    const [element, setElement] = (0,react.useState)(null);
    const measure = (0,react.useCallback)(()=>{
        if (element) {
            const { height  } = element.getBoundingClientRect();
            setHeight(height);
        }
    }, [
        element
    ]);
    (0,react.useEffect)(()=>{
        if (!element) return;
        // 初次測量高度
        measure();
        // 監聽 Resize 事件
        const resizeObserver = new ResizeObserver(()=>{
            measure();
        });
        resizeObserver.observe(element);
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        element,
        measure
    ]);
    return [
        setElement,
        height
    ];
};
/* harmony default export */ var hooks_useMeasureHeight = (useMeasureHeight);

// EXTERNAL MODULE: ./utils/hooks/fetchers.js
var fetchers = __webpack_require__(86700);
;// CONCATENATED MODULE: ./utils/api/hooks/useServiceClassification.js

const useServiceClassification = (id)=>{
    return (0,fetchers/* useCustomSWR */.LW)(id ? "/serviceClassifications/".concat(id) : null);
};

// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var qs_lib = __webpack_require__(80129);
// EXTERNAL MODULE: ./utils/request.js
var request = __webpack_require__(72673);
;// CONCATENATED MODULE: ./utils/api/hooks/useAdvancedFilterItems.js



const useAdvancedFilterItems = (dataSource)=>{
    const genUrl = ()=>{
        try {
            const props = typeof dataSource === "function" ? dataSource() : dataSource;
            if (props === null) {
                return null;
            }
            return [
                "/advancedFilterItems?".concat((0,qs_lib.stringify)(props)),
                request/* default.getToken */.ZP.getToken()
            ];
        } catch (err) {
            return null;
        }
    };
    return (0,fetchers/* useCustomSWR */.LW)(genUrl);
};

// EXTERNAL MODULE: ./utils/api/hooks/useVenderSupportItems.js
var useVenderSupportItems = __webpack_require__(56724);
;// CONCATENATED MODULE: ./utils/api/hooks/useVenderServiceCapacity.js

const useVenderServiceCapacity = (props)=>{
    const result = (0,useVenderSupportItems/* useVenderSupportItems */.q)(props ? {
        target: "serviceCapacity",
        serviceClassificationId: props.serviceClassificationId,
        county: props.county
    } : null);
    if (result === null || result === void 0 ? void 0 : result.data) return {
        ...result,
        data: result.data
    };
    return result;
};

;// CONCATENATED MODULE: ./utils/api/hooks/useVenders.js


const useVenders = (props, swrOptions)=>{
    const genUrl = ()=>{
        try {
            const propsObject = typeof props === "function" ? props() : props;
            if (propsObject === null) {
                return null;
            }
            return "/venders?".concat((0,qs_lib.stringify)({
                limit: 15,
                ...propsObject,
                isFilterListVisible: true
            }));
        } catch (err) {
            return null;
        }
    };
    return (0,fetchers/* useCustomSWR */.LW)(genUrl, swrOptions);
};

;// CONCATENATED MODULE: ./utils/api/hooks/useVenderCount.js


const useVenderCount = (props, swrOptions)=>{
    const genUrl = ()=>{
        try {
            const propsObject = typeof props === "function" ? props() : props;
            if (propsObject === null) {
                return null;
            }
            return "/venders/count?".concat((0,qs_lib.stringify)({
                limit: 15,
                ...propsObject,
                isFilterListVisible: true
            }));
        } catch (err) {
            return null;
        }
    };
    return (0,fetchers/* useCustomSWR */.LW)(genUrl, swrOptions);
};

;// CONCATENATED MODULE: ./utils/api/hooks/useInfiniteVenders.js


const useInfiniteVenders = (props, swrOptions)=>{
    const getVendersKey = (opts)=>(pageIndex, previousPageData)=>{
            const propsObject = typeof opts === "function" ? opts() : opts;
            if (propsObject === null) {
                return null;
            }
            if (previousPageData && !previousPageData.length) {
                return null;
            }
            const limit = propsObject.limit || 30;
            const params = {
                ...propsObject,
                limit: limit,
                skip: pageIndex * limit,
                isFilterListVisible: true
            };
            return "/venders?".concat((0,qs_lib.stringify)(params));
        };
    const { data , ...rest } = (0,fetchers/* useCustomSWRInfinite */.KU)(getVendersKey(props), swrOptions);
    // data會無預期出現數字，不確定為什麼，
    // 先避免直接回傳錯誤的資料類型
    return {
        data: typeof data === "number" ? [] : data,
        ...rest
    };
};

// EXTERNAL MODULE: ./utils/api/general/getServiceClassificationById.js
var getServiceClassificationById = __webpack_require__(84104);
// EXTERNAL MODULE: ./utils/hooks/index.js
var hooks = __webpack_require__(13946);
// EXTERNAL MODULE: ./utils/hooks/analytics/GtmAgent/GtmAgent.js
var GtmAgent = __webpack_require__(27582);
// EXTERNAL MODULE: ./store/webview/webviewSlice.js
var webviewSlice = __webpack_require__(86377);
// EXTERNAL MODULE: ./config/constants.js
var constants = __webpack_require__(73221);
// EXTERNAL MODULE: ./utils/address.js
var address = __webpack_require__(65428);
;// CONCATENATED MODULE: ./components/pages/Vender/VenderList/hooks.js
const getFilterInitialState = (param)=>{
    let { searchText , serviceCounty , serviceItem , serviceClassificationFilter  } = param;
    const filterState = {};
    if (searchText) {
        filterState.name = searchText;
    }
    if (serviceCounty) {
        filterState.serviceCounty = serviceCounty;
    }
    if (serviceItem) {
        filterState.serviceItem = serviceItem;
    }
    if (serviceClassificationFilter) {
        filterState.serviceClassificationName = serviceClassificationFilter === null || serviceClassificationFilter === void 0 ? void 0 : serviceClassificationFilter.name;
    }
    return filterState;
};
const filterReducer = (state, action)=>{
    switch(action.type){
        case "SET_SERVICE_ITEM":
            return {
                ...state,
                serviceItem: action.payload
            };
        case "SET_SERVICE_CLASSIFICATION_NAME":
            return {
                ...state,
                serviceClassificationName: action.payload
            };
        case "SET_FILTER_NAME":
            var _action_payload;
            return ((_action_payload = action.payload) === null || _action_payload === void 0 ? void 0 : _action_payload.length) ? {
                ...state,
                name: action.payload
            } : {
                ...state
            };
        case "SET_SERVICE_COUNTY":
            return {
                ...state,
                serviceCounty: action.payload
            };
        // case 'SET_CUSTOMER_BUDGET':
        //   return action.payload?.length || action.payload === 0
        //     ? { ...state, customerBudget: parseFloat(action.payload) }
        //     : { ...state }
        // case 'TOGGLE_ADVANCED_FILTER_ITEM': {
        //   const id = action.payload
        //   const isExist = state.advancedFilterItems?.includes(id)
        //   const updatedItems = isExist
        //     ? state.advancedFilterItems.filter((itemId) => itemId !== id)
        //     : [...(state.advancedFilterItems || []), id]
        //   return { ...state, advancedFilterItems: updatedItems }
        // }
        case "REMOVE_SERVICE_ITEM":
            {
                const { serviceItem , ...rest } = state;
                return rest;
            }
        case "REMOVE_SERVICE_CLASSIFICATION_NAME":
            {
                const { serviceClassificationName , ...rest1 } = state;
                return rest1;
            }
        case "REMOVE_FILTER_NAME":
            {
                const { name , ...rest2 } = state;
                return rest2;
            }
        case "REMOVE_SERVICE_COUNTY":
            {
                const { serviceCounty , ...rest3 } = state;
                return rest3;
            }
        // case 'REMOVE_CUSTOMER_BUDGET': {
        //   const { customerBudget, ...rest } = state
        //   return rest
        // }
        case "REMOVE_ADVANCED_FILTER_ITEM":
            {
                const updatedItems = state.advancedFilterItems.filter((item)=>item !== action.payload);
                return {
                    ...state,
                    advancedFilterItems: updatedItems
                };
            }
        // case 'REMOVE_ALL_ADVANCED_FILTERS': {
        //   const { name, advancedFilterItems, ...rest } = state
        //   return rest
        // }
        // case 'REPLACE_ADVANCE_FILTER_FIELDS': {
        //   const { name, advancedFilterItems } = action.payload
        //   return { ...state, name, advancedFilterItems }
        // }
        case "REPLACE_ALL":
            return action.payload;
        // --- 預設情況 ---
        default:
            throw new Error("filterReducer: UNEXPECTED_ACTION");
    }
};

// EXTERNAL MODULE: ./components/common/Layout/index.js
var Layout = __webpack_require__(82023);
// EXTERNAL MODULE: ./components/common/Header/index.js + 2 modules
var Header = __webpack_require__(75883);
// EXTERNAL MODULE: ./components/common/Footer/index.js + 12 modules
var Footer = __webpack_require__(56007);
// EXTERNAL MODULE: ./components/common/InfiniteContainer/index.js
var InfiniteContainer = __webpack_require__(26643);
// EXTERNAL MODULE: ./components/common/ContentWrapper/index.js
var ContentWrapper = __webpack_require__(55856);
// EXTERNAL MODULE: ./components/common/Pagination/index.js
var Pagination = __webpack_require__(92890);
// EXTERNAL MODULE: ./components/common/GutterGrid/index.js
var GutterGrid = __webpack_require__(46895);
// EXTERNAL MODULE: ./node_modules/lodash-es/throttle.js
var throttle = __webpack_require__(111);
;// CONCATENATED MODULE: ./components/common/StickyScroll/index.js

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: ",
        ";\n  top: ",
        ";\n  z-index: 10;\n  background-color: ",
        ";\n  transform: ",
        ";\n  opacity: ",
        ";\n  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05);\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}



const StickyScroll = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject(), (param)=>{
    let { isSticky  } = param;
    return isSticky ? "sticky" : "relative";
}, (param)=>{
    let { isSticky  } = param;
    return isSticky ? "0" : "unset";
}, (param)=>{
    let { theme  } = param;
    var _theme_palette, _theme_palette_background;
    return (theme === null || theme === void 0 ? void 0 : (_theme_palette = theme.palette) === null || _theme_palette === void 0 ? void 0 : (_theme_palette_background = _theme_palette.background) === null || _theme_palette_background === void 0 ? void 0 : _theme_palette_background.default) || "white";
}, (param)=>{
    let { isVisible  } = param;
    return isVisible ? "translateY(0)" : "translateY(-100%)";
}, (param)=>{
    let { isVisible  } = param;
    return isVisible ? 1 : 0;
});
const useStickyFilter = function(scrollContainerId) {
    let threshold = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 200;
    const [isVisible, setIsVisible] = (0,react.useState)(true) // 是否顯示
    ;
    const [isSticky, setIsSticky] = (0,react.useState)(false) // 是否啟用 sticky
    ;
    let lastScrollY = 0;
    (0,react.useEffect)(()=>{
        const scrollContainer = scrollContainerId ? document.getElementById(scrollContainerId) : window;
        const handleScroll = ()=>{
            const currentScrollY = scrollContainerId ? scrollContainer.scrollTop : window.scrollY;
            if (currentScrollY > threshold) {
                // 超過閾值啟用 sticky
                setIsSticky(true);
                if (currentScrollY < lastScrollY) {
                    // 向上滾動：顯示
                    setIsVisible(true);
                } else {
                    // 向下滾動：隱藏
                    setIsVisible(false);
                }
            } else {
                // 未超過閾值，關閉 sticky 並固定顯示
                setIsSticky(false);
                setIsVisible(true);
            }
            lastScrollY = currentScrollY;
        };
        const throttledScroll = (0,throttle/* default */.Z)(handleScroll, 100);
        scrollContainer.addEventListener("scroll", throttledScroll);
        return ()=>{
            scrollContainer.removeEventListener("scroll", throttledScroll);
            throttledScroll.cancel();
        };
    }, [
        scrollContainerId,
        threshold
    ]);
    return {
        StickyScroll,
        isSticky,
        isVisible
    };
};

// EXTERNAL MODULE: ./components/common/Select/index.js
var Select = __webpack_require__(78327);
// EXTERNAL MODULE: ./components/common/Hidden/index.js
var Hidden = __webpack_require__(18450);
// EXTERNAL MODULE: ./components/common/Modal/index.js
var Modal = __webpack_require__(37524);
// EXTERNAL MODULE: ./components/common/SVGElements/Close.js
var Close = __webpack_require__(71908);
// EXTERNAL MODULE: ./components/common/SVGElements/ArrowRight.js
var ArrowRight = __webpack_require__(69854);
// EXTERNAL MODULE: ./components/common/A/index.js
var A = __webpack_require__(79592);
// EXTERNAL MODULE: ./components/common/CursorPointerBox.js/index.js
var CursorPointerBox_js = __webpack_require__(69443);
;// CONCATENATED MODULE: ./components/pages/Vender/VenderList/VenderListItem/Logo.js

function Logo_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  overflow: hidden;\n  border-radius: 50%;\n  background-color: ",
        ";\n  width: ",
        ";\n  height: ",
        ";\n  min-width: ",
        ";\n"
    ]);
    Logo_templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  object-fit: cover;\n  width: ",
        ";\n  height: ",
        ";\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: white;\n  font-size: 20px;\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}


const Wrapper = emotion_styled_browser_esm/* default.div */.Z.div(Logo_templateObject(), (param)=>{
    let { theme  } = param;
    return theme.palette.primary.dark;
}, (param)=>{
    let { isLarge  } = param;
    return isLarge ? "80px" : "56px";
}, (param)=>{
    let { isLarge  } = param;
    return isLarge ? "80px" : "56px";
}, (param)=>{
    let { isLarge  } = param;
    return isLarge ? "80px" : "56px";
});
const Img = emotion_styled_browser_esm/* default.img */.Z.img(_templateObject1(), (param)=>{
    let { isLarge  } = param;
    return isLarge ? "80px" : "56px";
}, (param)=>{
    let { isLarge  } = param;
    return isLarge ? "80px" : "56px";
});
const Text = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject2());
const Name = (param)=>{
    let { value  } = param;
    const index = value === null || value === void 0 ? void 0 : value.search(/(科技|有限|公司|工程|實業|室內|裝修|設計|企業)/);
    const string = index > -1 ? value.slice(0, index) : value;
    const shortcut = (string === null || string === void 0 ? void 0 : string.length) > 4 ? string.slice(0, 4) : string;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
        children: shortcut
    });
};
Name.defaultProps = {
    value: ""
};
const Logo = (param)=>{
    let { img , name , isLarge =true  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        isLarge: isLarge,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Img, {
            alt: name,
            src: img || "/img/img_headshot_default.png",
            isLarge: isLarge
        })
    });
};
/* harmony default export */ var VenderListItem_Logo = (Logo);

// EXTERNAL MODULE: ./utils/api/general/setVenderViewedOrClicked.js
var setVenderViewedOrClicked = __webpack_require__(3491);
// EXTERNAL MODULE: ./utils/helpers/vender-welcome-info.js
var vender_welcome_info = __webpack_require__(19575);
// EXTERNAL MODULE: ./utils/helpers/vender-joined-years.js
var vender_joined_years = __webpack_require__(75082);
;// CONCATENATED MODULE: ./components/pages/Vender/VenderList/VenderListItem/index.js

function VenderListItem_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  // 子元素保持原本的寬度，不被壓縮\n  & > * {\n    flex-shrink: 0;\n  }\n  display: -webkit-box;\n  webkitboxorient: vertical;\n  overflow: hidden;\n  line-height: 1.5em;\n  max-height: 1.5em;\n"
    ]);
    VenderListItem_templateObject = function() {
        return data;
    };
    return data;
}
function VenderListItem_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    VenderListItem_templateObject1 = function() {
        return data;
    };
    return data;
}












const ArticleKeywordWrapper = (0,emotion_styled_browser_esm/* default */.Z)(Typography/* default */.Z)(VenderListItem_templateObject());
const StyleCursorBox = (0,emotion_styled_browser_esm/* default */.Z)(CursorPointerBox_js/* default */.Z)(VenderListItem_templateObject1(), (param)=>{
    let { theme , isLarge  } = param;
    return "\n    border-bottom: 1px solid ".concat(theme.palette.grey.secondary, ";\n    padding:  ").concat(isLarge ? "24px 0" : "16px 0", ";\n  ");
});
const VenderListItem = (param)=>{
    let { vender , isLarge , filterState  } = param;
    var _vender_introductionInfo, _vender_ownQualityTag, _vender_venderServiceItems;
    const [onHover, setOnHover] = (0,react.useState)(false);
    const { logoImage , favorableDiscountText  } = (0,vender_welcome_info/* getVenderWelcomeInfo */.u)(vender);
    const joinedYears = (0,vender_joined_years/* getVenderJoinedYears */.L)(vender === null || vender === void 0 ? void 0 : (_vender_introductionInfo = vender.introductionInfo) === null || _vender_introductionInfo === void 0 ? void 0 : _vender_introductionInfo.joinedSinyiLivingDate);
    const venderInfoLabels = [
        ...joinedYears >= 1 ? [
            "已加入信義居家 ".concat(joinedYears, " 年")
        ] : [],
        ...((vender === null || vender === void 0 ? void 0 : (_vender_ownQualityTag = vender.ownQualityTag) === null || _vender_ownQualityTag === void 0 ? void 0 : _vender_ownQualityTag.qualityTags) || []).map((tag)=>tag.name)
    ];
    const sendVenderGTM = async (vender, filterState)=>{
        try {
            var _vender_introductionInfo;
            GtmAgent/* GtmAgent.directSendToGTM */.b.directSendToGTM({
                event: "living_action",
                living_event_name: "select_vender",
                living_vender: (vender === null || vender === void 0 ? void 0 : vender.name) || "",
                living_vender_county: ((vender === null || vender === void 0 ? void 0 : (_vender_introductionInfo = vender.introductionInfo) === null || _vender_introductionInfo === void 0 ? void 0 : _vender_introductionInfo.serviceCounties) || []).join("、"),
                living_vender_service: (vender.venderServiceItems.map((item)=>item.serviceClassification.name) || []).join("、"),
                living_filter_county: (filterState === null || filterState === void 0 ? void 0 : filterState.serviceCounty) || "",
                living_filter_service: (filterState === null || filterState === void 0 ? void 0 : filterState.serviceClassificationName) || ""
            });
        } catch (error) {
            console.error("Error fetching services:", error);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(A/* default */.Z, {
        href: "/vender/".concat(vender === null || vender === void 0 ? void 0 : vender.urlId).concat(filterState.serviceItem ? "?serviceItem=".concat(filterState.serviceItem) : ""),
        target: "_blank",
        rel: "noopener noreferrer",
        onClick: ()=>{
            sendVenderGTM(vender, filterState);
            (0,setVenderViewedOrClicked/* setVenderViewedOrClicked */.Y)(vender._id, {
                isAddClick: true
            });
        },
        onMouseEnter: ()=>setOnHover(true),
        onMouseLeave: ()=>setOnHover(false),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyleCursorBox, {
            isLarge: isLarge,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    display: "flex",
                    gap: 2,
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(VenderListItem_Logo, {
                            img: logoImage === null || logoImage === void 0 ? void 0 : logoImage.url,
                            name: vender === null || vender === void 0 ? void 0 : vender.shortname,
                            isLarge: isLarge
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            display: "flex",
                            gap: 1,
                            flexDirection: "column",
                            alignItems: "start",
                            sx: {
                                typography: "bodyXs"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: isLarge ? "headlineSmall" : "titleLarge",
                                    color: onHover ? "text.minus2" : "text.minus1",
                                    sx: {
                                        display: "-webkit-box",
                                        WebkitBoxOrient: "vertical",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        WebkitLineClamp: 2
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                        fontWeight: "fontWeightBold",
                                        children: vender === null || vender === void 0 ? void 0 : vender.shortname
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleKeywordWrapper, {
                                    variant: "body2",
                                    color: "text.secondary",
                                    children: venderInfoLabels.map((label, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                            display: "inline-block",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                variant: isLarge ? "bodySmall" : "bodyXs",
                                                children: [
                                                    index > 0 && "・",
                                                    label
                                                ]
                                            })
                                        }, index))
                                })
                            ]
                        })
                    ]
                }),
                (vender === null || vender === void 0 ? void 0 : (_vender_venderServiceItems = vender.venderServiceItems) === null || _vender_venderServiceItems === void 0 ? void 0 : _vender_venderServiceItems.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "paraBodyMedium",
                    color: "text.minus1",
                    mt: isLarge ? 4 : 2,
                    children: vender === null || vender === void 0 ? void 0 : vender.venderServiceItems.map((item)=>{
                        var _item_serviceClassification, _item_serviceClassification1;
                        return (item === null || item === void 0 ? void 0 : (_item_serviceClassification = item.serviceClassification) === null || _item_serviceClassification === void 0 ? void 0 : _item_serviceClassification.isVenderFilterListVisible) ? item === null || item === void 0 ? void 0 : (_item_serviceClassification1 = item.serviceClassification) === null || _item_serviceClassification1 === void 0 ? void 0 : _item_serviceClassification1.name : null;
                    }).filter(Boolean).join(" / ")
                }),
                !!favorableDiscountText && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    p: 2,
                    mt: isLarge ? 2 : 1,
                    bgcolor: "primary.bgPlus2",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                        variant: "labelLarge",
                        color: "text.minus2",
                        sx: {
                            display: "-webkit-box",
                            WebkitBoxOrient: "vertical",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            WebkitLineClamp: 1
                        },
                        children: [
                            "特色優惠",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                component: "span",
                                sx: {
                                    typography: "bodySmall"
                                },
                                color: "text.minus1",
                                fontWeight: "fontWeightRegular",
                                ml: 1,
                                children: favorableDiscountText
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var VenderList_VenderListItem = (VenderListItem);

// EXTERNAL MODULE: ./components/pages/Vender/constants.js
var Vender_constants = __webpack_require__(7676);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/FormControlLabel/FormControlLabel.js + 1 modules
var FormControlLabel = __webpack_require__(22841);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Radio/Radio.js + 5 modules
var Radio = __webpack_require__(8519);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/RadioGroup/RadioGroup.js
var RadioGroup = __webpack_require__(41470);
;// CONCATENATED MODULE: ./utils/api/hooks/useCatalogsVendorListings.js



const useCatalogsVendorListings = function() {
    let props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        limit: 999
    };
    const genUrl = ()=>request/* default.getToken */.ZP.getToken() ? [
            "/catalogs/vendorListings?".concat((0,qs_lib.stringify)(props)),
            request/* default.getToken */.ZP.getToken()
        ] : "/catalogs/vendorListings?".concat((0,qs_lib.stringify)(props));
    return (0,fetchers/* useCustomSWR */.LW)(genUrl, request/* lsGetWithToken */.n8);
};

// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Button/Button.js + 2 modules
var Button = __webpack_require__(75084);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/FormControl/FormControl.js + 1 modules
var FormControl = __webpack_require__(55343);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/MenuItem/MenuItem.js + 3 modules
var MenuItem = __webpack_require__(90060);
// EXTERNAL MODULE: ./node_modules/@mui/base/ClickAwayListener/ClickAwayListener.js
var ClickAwayListener = __webpack_require__(23926);
;// CONCATENATED MODULE: ./components/common/PopupRadioSelect/index.js

function PopupRadioSelect_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    PopupRadioSelect_templateObject = function() {
        return data;
    };
    return data;
}















const StyledModal = emotion_styled_browser_esm/* default.div */.Z.div(PopupRadioSelect_templateObject(), (param)=>{
    let { theme , $top , $left , $right , $width , $alignRight , $maxWidth , $maxHeight  } = param;
    return "\n    position: absolute;\n    top: ".concat($top, "px;\n    left: ").concat($left, "px;\n    right: ").concat($right, "px;\n    width: ").concat($width, "px;\n    max-width: ").concat($maxWidth, "px;\n    min-height: 100px;\n    max-height: ").concat($maxHeight, "px;\n    background-color: white;\n    z-index: 1;\n    border-radius: ").concat($alignRight ? "6px 0px 6px 6px" : "0px 6px 6px 6px", ";\n    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);\n    border: 1px solid ").concat(theme.palette.background.line, ";\n    overflow: auto;\n    padding: 18px 15px;\n  ");
});
const calculateModalPosition = (e)=>{
    const top = e.target.clientHeight - 2;
    const width = window.innerWidth < 768 ? Math.floor(window.innerWidth * 0.9) : Math.floor(window.innerWidth * 0.4);
    const maxWidth = 320;
    const modalRectTop = e.target.getBoundingClientRect().top + e.target.clientHeight - 2;
    const maxHeight = (0,max/* default */.Z)([
        window.innerHeight - modalRectTop,
        250
    ]);
    const modalRectLeft = e.target.getBoundingClientRect().left;
    const alignRight = modalRectLeft + width > window.innerWidth;
    const left = alignRight ? "unset" : 0;
    const right = alignRight ? 0 : "unset";
    return {
        top,
        left,
        right,
        width,
        maxWidth,
        maxHeight,
        alignRight
    };
};
const PopupRadioSelect = (param)=>{
    let { placeholder ="" , selectedText ="" , modalContent , onOpen , closeModalOnInnerClick =true , fullWidth , size , isLarge , onChange , selectedId , isMobile  } = param;
    const [desktopFilterModal, setDesktopFilterModal] = (0,react.useState)({
        open: false
    });
    const [mobileFilterModal, setMobileFilterModal] = (0,react.useState)({
        open: false
    });
    const handleSelectClick = (e)=>{
        const modalPosition = calculateModalPosition(e);
        setDesktopFilterModal((prev)=>({
                open: !prev.open,
                ...modalPosition
            }));
        if (!desktopFilterModal.open && onOpen) onOpen();
    };
    const handleModalClick = ()=>{
        if (closeModalOnInnerClick) {
            setTimeout(()=>{
                setDesktopFilterModal({
                    open: false
                });
            }, 0);
        }
    };
    const handleMobileFilterModalClose = ()=>setMobileFilterModal({
            open: false
        });
    const handleMobileFilterModalConfirm = ()=>{
        setMobileFilterModal({
            open: false
        });
        if (onChange) onChange(selectedId);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickAwayListener/* default */.Z, {
        onClickAway: ()=>setDesktopFilterModal({
                open: false
            }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl/* default */.Z, {
            fullWidth: fullWidth,
            sx: {
                ...isMobile && {
                    display: "contents"
                }
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Select/* default */.Z, {
                    open: false,
                    value: !!selectedText || "",
                    native: false,
                    size: size,
                    displayEmpty: true,
                    onClick: !isLarge ? ()=>setMobileFilterModal({
                            open: true
                        }) : handleSelectClick,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                            value: "",
                            children: placeholder
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                            value: true,
                            children: selectedText
                        })
                    ]
                }),
                !isLarge ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* FunctionModal */.rK, {
                    open: mobileFilterModal.open,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        display: "flex",
                        flexDirection: "column",
                        height: "100%",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                display: "flex",
                                justifyContent: "center",
                                p: 4,
                                position: "relative",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                        sx: {
                                            position: "absolute",
                                            left: "10px"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* CloseSVG */.b, {
                                            onClick: handleMobileFilterModalClose
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "titleSmall",
                                        children: "服務"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* ScrollableBox */.N1, {
                                flexGrow: 1,
                                mt: 4,
                                mx: 4,
                                children: modalContent
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                p: 5,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                    container: true,
                                    spacing: 5,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                        item: true,
                                        xs: 12,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            variant: "contained",
                                            fullWidth: true,
                                            onClick: handleMobileFilterModalConfirm,
                                            children: "送出"
                                        })
                                    })
                                })
                            })
                        ]
                    })
                }) : desktopFilterModal.open && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledModal, {
                    $top: desktopFilterModal.top,
                    $left: desktopFilterModal.left,
                    $right: desktopFilterModal.right,
                    $alignRight: desktopFilterModal.alignRight,
                    $width: desktopFilterModal.width,
                    $maxHeight: desktopFilterModal.maxHeight,
                    $maxWidth: desktopFilterModal.maxWidth,
                    onClick: handleModalClick,
                    children: modalContent
                })
            ]
        })
    });
};
/* harmony default export */ var common_PopupRadioSelect = (PopupRadioSelect);

;// CONCATENATED MODULE: ./components/pages/Vender/VenderList/ServiceClassificationSelectRadio.js






const StyleFormControlLabel = (0,emotion_styled_browser_esm/* default */.Z)(FormControlLabel/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        margin: 0,
        maxWidth: "100%",
        wordBreak: "break-word",
        "& .MuiFormControlLabel-label": {
            ...theme.typography.paraBodyMedium,
            paddingLeft: "8px"
        }
    };
});
const ServiceClassificationSelectRadio = (param)=>{
    let { value , onChange , fullWidth , size , isLarge , isMobile  } = param;
    // Fetching data
    const { data: catalogs  } = useCatalogsVendorListings();
    const { data: currentClassification  } = useServiceClassification(value);
    // State management
    const [selectedValue, setSelectedValue] = (0,react.useState)("");
    const [selectedName, setSelectedName] = (0,react.useState)("");
    // Effect to update selected name
    (0,react.useEffect)(()=>{
        if (currentClassification === null || currentClassification === void 0 ? void 0 : currentClassification.name) {
            setSelectedName(currentClassification.name);
        } else {
            setSelectedName("");
        }
    }, [
        currentClassification === null || currentClassification === void 0 ? void 0 : currentClassification.name
    ]);
    (0,react.useEffect)(()=>{
        setSelectedValue(value || "");
    }, [
        value
    ]);
    // Handle selection change
    const handleSelectionChange = (event)=>{
        const selectedId = event.target.value;
        const selectedName = event.target.name;
        setSelectedValue(selectedId);
        if (isLarge && onChange) {
            onChange(selectedId, selectedName);
        }
    };
    // Handle click for unselecting
    const handleSelectionClick = (event)=>{
        const selectedId = event.target.value;
        if (selectedId === selectedValue) {
            if (isLarge && onChange) {
                onChange(null, null);
                setSelectedName("");
            }
            setSelectedValue("");
        }
    };
    const renderSubcatalogItems = (items)=>{
        return items === null || items === void 0 ? void 0 : items.map((item)=>{
            var _item_serviceClassification, _item_serviceClassification1, _item_serviceClassification2, _item_serviceClassification3;
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(StyleFormControlLabel, {
                value: (_item_serviceClassification = item.serviceClassification) === null || _item_serviceClassification === void 0 ? void 0 : _item_serviceClassification._id,
                name: (_item_serviceClassification1 = item.serviceClassification) === null || _item_serviceClassification1 === void 0 ? void 0 : _item_serviceClassification1.name,
                control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {
                    onClick: (e)=>{
                        handleSelectionClick(e);
                    },
                    sx: {
                        padding: 0,
                        margin: 0
                    }
                }),
                label: (_item_serviceClassification2 = item.serviceClassification) === null || _item_serviceClassification2 === void 0 ? void 0 : _item_serviceClassification2.name
            }, (_item_serviceClassification3 = item.serviceClassification) === null || _item_serviceClassification3 === void 0 ? void 0 : _item_serviceClassification3._id);
        });
    };
    const renderSubcatalogs = (subcatalogs)=>{
        return subcatalogs === null || subcatalogs === void 0 ? void 0 : subcatalogs.map((subcatalog)=>{
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    subcatalogs.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "paraBodyMedium",
                        children: subcatalog.name
                    }),
                    renderSubcatalogItems(subcatalog === null || subcatalog === void 0 ? void 0 : subcatalog.items)
                ]
            }, subcatalog._id);
        });
    };
    const renderCatalogs = ()=>{
        return catalogs === null || catalogs === void 0 ? void 0 : catalogs.map((catalog)=>{
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "paraTitleSmall",
                        children: catalog.name
                    }),
                    renderSubcatalogs(catalog === null || catalog === void 0 ? void 0 : catalog.subcatalogs)
                ]
            }, catalog._id);
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(common_PopupRadioSelect, {
        fullWidth: fullWidth,
        placeholder: "服務",
        selectedText: selectedName,
        size: size,
        isLarge: isLarge,
        isMobile: isMobile,
        onChange: onChange,
        selectedId: selectedValue,
        modalContent: /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioGroup/* default */.Z, {
            value: selectedValue,
            onChange: handleSelectionChange,
            sx: {
                gap: "20px"
            },
            children: renderCatalogs()
        })
    });
};
/* harmony default export */ var VenderList_ServiceClassificationSelectRadio = (ServiceClassificationSelectRadio);

// EXTERNAL MODULE: ./components/pages/Vender/VenderList/AdvanceFilters/index.js
var AdvanceFilters = __webpack_require__(85459);
;// CONCATENATED MODULE: ./components/pages/Vender/VenderList/AdvancedFilterSelection.js









const AdvancedFilterSelection = (param)=>{
    let { state , dispatch , isLarge , registerOpenModal  } = param;
    const [filterModal, setFilterModal] = (0,react.useState)({
        open: false
    });
    const onClose = ()=>setFilterModal({
            open: false
        });
    const [nameInput, setNameInput] = (0,react.useState)("");
    const [cache, cacheDispatch] = (0,react.useReducer)(filterReducer, state);
    (0,react.useEffect)(()=>{
        registerOpenModal(()=>setFilterModal({
                open: true
            }));
    }, [
        registerOpenModal
    ]);
    (0,react.useEffect)(()=>{
        if (filterModal.open && state !== cache) {
            cacheDispatch({
                type: "REPLACE_ALL",
                payload: state
            });
        }
    }, [
        filterModal.open
    ]);
    const onConfirm = ()=>{
        dispatch({
            type: "SET_FILTER_NAME",
            payload: nameInput
        });
        setFilterModal({
            open: false
        });
    };
    const onRemoveFilteredName = ()=>{
        dispatch({
            type: "REMOVE_FILTER_NAME"
        });
        setFilterModal({
            open: false
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* FunctionModal */.rK, {
        open: filterModal.open,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            display: "flex",
            flexDirection: "column",
            height: "100%",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* ScrollableBox */.N1, {
                    flexGrow: 1,
                    mt: 4,
                    mx: 4,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvanceFilters["default"], {
                        serviceClassificationName: cache === null || cache === void 0 ? void 0 : cache.name,
                        serviceClassification: cache.serviceItem,
                        advancedFilterItems: cache.advancedFilterItems,
                        isLarge: isLarge,
                        onRemoveFilteredName: onRemoveFilteredName,
                        onSubmitNameInput: (name)=>setNameInput(name),
                        onClose: onClose,
                        dispatch: cacheDispatch
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    p: 5,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        container: true,
                        spacing: 5,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                variant: "contained",
                                fullWidth: true,
                                onClick: onConfirm,
                                children: "送出"
                            })
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var VenderList_AdvancedFilterSelection = (AdvancedFilterSelection);

// EXTERNAL MODULE: ./components/common/NowrapDiv/index.js
var NowrapDiv = __webpack_require__(2925);
;// CONCATENATED MODULE: ./components/pages/Vender/VenderList/index.js

function VenderList_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 236px;\n  max-width: 100%;\n"
    ]);
    VenderList_templateObject = function() {
        return data;
    };
    return data;
}
function VenderList_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: sticky;\n  margin-bottom: 0;\n  top: ",
        ";\n"
    ]);
    VenderList_templateObject1 = function() {
        return data;
    };
    return data;
}
function VenderList_templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  padding-top: 50%;\n"
    ]);
    VenderList_templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}










































const DynamicAdvanceFilters = dynamic_default()(()=>Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 85459)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(85459)
            ]
    },
    ssr: false
});
const DynamicAlbumContent = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(6760), __webpack_require__.e(2334), __webpack_require__.e(546)]).then(__webpack_require__.bind(__webpack_require__, 22334)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(22334)
            ]
    }
});
const areaData = (0,address/* default */.Z)();
const NUMBER_PER_PAGE = 10;
const VenderList_Img = emotion_styled_browser_esm/* default.img */.Z.img(VenderList_templateObject());
const Sticky = emotion_styled_browser_esm/* default.div */.Z.div(VenderList_templateObject1(), (param)=>{
    let { isSticky , isVisible , topOffset  } = param;
    return isSticky && isVisible ? "".concat(topOffset, "px") : "0px";
});
const Rect = emotion_styled_browser_esm/* default.div */.Z.div(VenderList_templateObject2());
const Tag = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject3(), (param)=>{
    let { theme  } = param;
    return "\n    padding: 10px 12px;\n    border-radius: 20px;\n    border: 1px solid ".concat(theme.palette.background.line, ";\n  ");
});
const VenderList = (param)=>{
    let { isMobile , fallbackData  } = param;
    var _router_query, _filterState_advancedFilterItems, _filterState_advancedFilterItems1;
    // filtering
    const [filterState, filterDispatch] = (0,react.useReducer)(filterReducer, getFilterInitialState(fallbackData));
    const onServiceClassificationChange = (id, name)=>{
        // 判斷是否需要檢查 id === filterState.serviceItem
        const shouldCheckSameId = isLarge ? id === filterState.serviceItem : false;
        if (!id || shouldCheckSameId) {
            (0,es/* batch */.dC)(()=>{
                filterDispatch({
                    type: "REMOVE_SERVICE_ITEM"
                });
                filterDispatch({
                    type: "REMOVE_SERVICE_CLASSIFICATION_NAME"
                });
            });
        } else {
            (0,es/* batch */.dC)(()=>{
                filterDispatch({
                    type: "SET_SERVICE_ITEM",
                    payload: id
                });
                filterDispatch({
                    type: "SET_SERVICE_CLASSIFICATION_NAME",
                    payload: name
                });
            });
        }
    };
    const onServiceClassificationRemove = ()=>{
        filterDispatch({
            type: "REMOVE_SERVICE_ITEM"
        });
    };
    const onCountyChange = (e)=>{
        filterDispatch({
            type: "SET_SERVICE_COUNTY",
            payload: e.target.value
        });
    };
    const onRemoveCustomerBudget = ()=>{
        filterDispatch({
            type: "REMOVE_CUSTOMER_BUDGET"
        });
    };
    const onRemoveFilteredName = ()=>{
        filterDispatch({
            type: "REMOVE_FILTER_NAME"
        });
    };
    const onRemoveAdvancedFilterItem = (item)=>{
        filterDispatch({
            type: "REMOVE_ADVANCED_FILTER_ITEM",
            payload: item
        });
    };
    // const onRemoveAllAdvancedFilters = () => {
    //   filterDispatch({ type: 'REMOVE_ALL_ADVANCED_FILTERS' })
    // }
    const [page, setPage] = (0,react.useState)((fallbackData === null || fallbackData === void 0 ? void 0 : fallbackData.page) || 1);
    const containerId = "vender-list-scrollable";
    const [ref, height] = hooks_useMeasureHeight();
    const { StickyScroll , isVisible , isSticky  } = useStickyFilter(containerId, height);
    const router = (0,next_router.useRouter)();
    let openModal = null;
    const handleOpenModal = ()=>{
        if (openModal) {
            openModal();
        }
    };
    const { data: serviceClassification  } = useServiceClassification(filterState.serviceItem);
    const { data: filterItemInfos  } = useAdvancedFilterItems(()=>{
        return serviceClassification ? {
            serviceClassification: serviceClassification === null || serviceClassification === void 0 ? void 0 : serviceClassification._id,
            limit: 200
        } : null;
    });
    // 使用 useVenderServiceCapacity 檢查是否顯示服務推薦區塊
    const { data: supportServiceData  } = useVenderServiceCapacity(filterState.serviceItem ? {
        serviceClassificationId: filterState.serviceItem,
        county: filterState.serviceCounty
    } : null);
    const filterItemMap = (0,react.useMemo)(()=>{
        return new Map((filterItemInfos || []).map((item)=>[
                item._id,
                item.name
            ]));
    }, [
        filterItemInfos
    ]);
    // 當fallbackData.searchText變化時表示發生page route，
    // 此時將頁碼設回1
    (0,react.useEffect)(()=>{
        if ((fallbackData === null || fallbackData === void 0 ? void 0 : fallbackData.searchText) && (fallbackData === null || fallbackData === void 0 ? void 0 : fallbackData.searchText) !== filterState.name) {
            filterDispatch({
                type: "SET_FILTER_NAME",
                payload: fallbackData.searchText
            });
            setPage(1);
        }
    }, [
        fallbackData === null || fallbackData === void 0 ? void 0 : fallbackData.searchText
    ]);
    // 讓query string跟著頁碼變動
    (0,react.useEffect)(()=>{
        var _window_location_href_split;
        const qs = ((_window_location_href_split = window.location.href.split("?")) === null || _window_location_href_split === void 0 ? void 0 : _window_location_href_split[1]) || "";
        const pageInQs = qs.split("&").filter((string)=>/^page=/.test(string)).map((string)=>string.split("=")[1] || "").shift();
        if (parseInt(pageInQs) !== page) {
            const newQs = qs.split("&").filter((string)=>string && !/^page=/.test(string)).concat([
                "page=".concat(page)
            ]).join("&");
            const path = location.pathname + "?" + newQs;
            if (page && !pageInQs) {
                router.replace(path, undefined, {
                    shallow: true
                });
            } else {
                router.push(path, undefined, {
                    shallow: true
                });
            }
        }
    }, [
        page
    ]);
    // 讓query string跟著篩選變動
    (0,use_deep_compare_effect_esm/* default */.ZP)(()=>{
        var _window_location_href_split;
        const qs = ((_window_location_href_split = window.location.href.split("?")) === null || _window_location_href_split === void 0 ? void 0 : _window_location_href_split[1]) || "";
        const filterValues = [];
        for (const [key, value] of Object.entries(filterState)){
            if (key === "serviceClassificationName") {
                continue;
            }
            if (key === "serviceCounty") {
                !!value && filterValues.push("serviceCounty=".concat(value));
            } else if (key === "advancedFilterItems") {
                if (!!value) {
                    const queryValue = value === null || value === void 0 ? void 0 : value.map((item, index)=>{
                        const queryValueItem = index === 0 ? item : "".concat(item, "+");
                        return queryValueItem;
                    });
                    filterValues.push("".concat(key, "=").concat(queryValue.join("")));
                }
            } else if (key === "serviceItem") {
                !!value && filterValues.push("serviceItem=".concat(value));
            } else {
                if (!!value) {
                    ;
                    ((0,isNumber/* default */.Z)(value) || !!(value === null || value === void 0 ? void 0 : value.length)) && filterValues.push("".concat(key, "=").concat(value));
                }
            }
        }
        const newQs = qs.split("&").filter((string)=>string && /^page=/.test(string)).concat(filterValues).join("&");
        setPage(1);
        window.history.replaceState(window.history.state, "", "?".concat(newQs));
    }, [
        filterState
    ]);
    // 當query變動時，檢查是否需要調整篩選條件
    (0,react.useEffect)(()=>{
        if (router.isReady) {
            // 定義所有篩選條件的 key
            const allFilterKeys = [
                "serviceItem",
                "serviceCounty",
                // 'customerBudget',
                // 'advancedFilterItems',
                "name"
            ];
            // 導向初始廠商列表頁
            const handleRouteChange = ()=>{
                router.replace("/vender", {
                    shallow: true
                });
            };
            // 確認 url 上的 serviceItem 是否可以出現在篩選列表中
            const handleServiceItem = async (serviceItemId)=>{
                try {
                    // 先檢查該 serviceItem 是否有效
                    const [serviceClassificationData, error] = await (0,getServiceClassificationById/* getServiceClassificationById */.J)(serviceItemId);
                    // 若不該出現在篩選列表或發生非預期錯誤
                    if (serviceClassificationData.isVenderFilterListVisible === false || error || !serviceClassificationData) {
                        handleRouteChange();
                        return;
                    }
                    // 若驗證通過則設置到 filterState
                    filterDispatch({
                        type: "SET_SERVICE_ITEM",
                        payload: serviceItemId
                    });
                } catch (err) {
                    console.error("Failed to validate serviceItem:", err);
                    // 發生其他非預期錯誤時也導向初始廠商列表頁
                    handleRouteChange();
                }
            };
            // 更新存在於 router.query 中的篩選條件
            for (const [key, value] of Object.entries(router.query)){
                if (key === "serviceItem") {
                    handleServiceItem(value);
                } else if (key === "serviceCounty") {
                    filterDispatch({
                        type: "SET_SERVICE_COUNTY",
                        payload: value
                    });
                // } else if (key === 'customerBudget') {
                //   filterDispatch({ type: 'SET_CUSTOMER_BUDGET', payload: value });
                // } else if (key === 'advancedFilterItems') {
                //   const advancedFilterItems = value.split('+');
                //   advancedFilterItems.forEach((item) => {
                //     filterDispatch({
                //       type: 'TOGGLE_ADVANCED_FILTER_ITEM',
                //       payload: item,
                //     });
                //   });
                } else if (key === "name" || key === "keyword") {
                    filterDispatch({
                        type: "SET_FILTER_NAME",
                        payload: value
                    });
                }
            }
            // 執行 REMOVE 操作，清除不存在於 router.query 中的條件
            allFilterKeys.forEach((key)=>{
                if (!(key in router.query) && !(key === "name" && "keyword" in router.query // 若 key 是 name，還要檢查 keyword 是否存在
                )) {
                    switch(key){
                        case "serviceItem":
                            filterDispatch({
                                type: "REMOVE_SERVICE_ITEM"
                            });
                            filterDispatch({
                                type: "REMOVE_SERVICE_CLASSIFICATION_NAME"
                            });
                            break;
                        case "serviceCounty":
                            filterDispatch({
                                type: "REMOVE_SERVICE_COUNTY"
                            });
                            break;
                        // case 'customerBudget':
                        //   filterDispatch({ type: 'REMOVE_CUSTOMER_BUDGET' });
                        //   break;
                        // case 'advancedFilterItems':
                        //   filterDispatch({ type: 'REMOVE_ALL_ADVANCED_FILTERS' });
                        //   break;
                        case "name":
                            filterDispatch({
                                type: "REMOVE_FILTER_NAME"
                            });
                            break;
                        default:
                            break;
                    }
                }
            });
        }
    }, [
        router.isReady,
        router.query
    ]);
    // 讓頁碼隨著query string變動
    (0,react.useEffect)(()=>{
        var _window_location_href_split;
        if (!router.isReady) {
            return;
        }
        const qs = ((_window_location_href_split = window.location.href.split("?")) === null || _window_location_href_split === void 0 ? void 0 : _window_location_href_split[1]) || "";
        const pageInQs = qs.split("&").filter((string)=>/^page=/.test(string)).map((string)=>string.split("=")[1] || "").shift();
        if (pageInQs && parseInt(pageInQs) !== page) {
            setPage(parseInt(pageInQs));
        }
    }, [
        router.isReady,
        (_router_query = router.query) === null || _router_query === void 0 ? void 0 : _router_query.page
    ]);
    const { data: paginatedVenders , isLoading: isPaginatedVendersLoading  } = useVenders(()=>{
        if (isMobile) {
            return null;
        }
        const query = {
            skip: (0,max/* default */.Z)([
                page - 1,
                0
            ]) * NUMBER_PER_PAGE,
            limit: NUMBER_PER_PAGE
        };
        return {
            ...query,
            ...filterState
        };
    });
    const { data: venderCount  } = useVenderCount(filterState);
    const { data: infiniteVenders , isLoading: isInfiniteVendersLoading , size , setSize  } = useInfiniteVenders(()=>{
        if (!isMobile) {
            return null;
        }
        const query = {
            limit: NUMBER_PER_PAGE
        };
        return {
            ...query,
            ...filterState
        };
    });
    const isVendersLoading = !isMobile ? isPaginatedVendersLoading : isInfiniteVendersLoading;
    const vendersData = (0,flatten/* default */.Z)(!isMobile ? paginatedVenders : infiniteVenders);
    const venders = (0,sortBy/* default */.Z)(vendersData, [
        (vender)=>-(vender.sortOrder || 0),
        (vender)=>-new Date(vender.createdAt).getTime()
    ]);
    const onLoadMore = ()=>setSize(size + 1);
    // album content modal
    const webview = (0,es/* useSelector */.v9)(webviewSlice/* selectWebview */.hn);
    const { albumModal , closeAlbumModal , onAlbumClick , onAlbumContentClose  } = (0,hooks/* useAlbumModal */.Xh)("/vender", router, {
        webview,
        nativeHeaderHandler: ()=>null
    });
    const theme = (0,useTheme/* default */.Z)();
    const isLarge = (0,useMediaQuery/* default */.Z)(theme.breakpoints.up("lg"));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        stickyHeader: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {}),
        fixContentHeight: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfiniteContainer/* default */.Z, {
                id: containerId,
                filterState: filterState,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StickyScroll, {
                        isVisible: isVisible,
                        isSticky: isSticky,
                        ref: ref,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentWrapper/* default */.Z, {
                            children: [
                                !isSticky && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: isLarge ? "h4" : "h5",
                                    fontWeight: "700",
                                    mt: 6,
                                    children: "服務廠商一覽"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                    container: true,
                                    spacing: 0,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                            item: true,
                                            xs: 12,
                                            p: 0,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                                py: isLarge ? 6 : 4,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                        display: "flex",
                                                        flexDirection: "row",
                                                        alignItems: "center",
                                                        gap: isLarge ? 4 : 2,
                                                        sx: {
                                                            ...isMobile ? {
                                                                overflow: "scroll",
                                                                scrollbarWidth: "none",
                                                                scrollBehavior: "smooth"
                                                            } : {
                                                                width: "0px",
                                                                flex: "1",
                                                                maxWidth: "fit-content"
                                                            }
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(VenderList_ServiceClassificationSelectRadio, {
                                                                fullWidth: true,
                                                                value: filterState.serviceItem,
                                                                onChange: onServiceClassificationChange,
                                                                onRemove: onServiceClassificationRemove,
                                                                size: isLarge ? "medium" : "small",
                                                                isLarge: isLarge,
                                                                isMobile: isMobile
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* default */.Z, {
                                                                label: "縣市",
                                                                fullWidth: false,
                                                                size: isLarge ? "medium" : "small",
                                                                value: filterState.serviceCounty,
                                                                sx: {
                                                                    minWidth: "fit-content"
                                                                },
                                                                onChange: onCountyChange,
                                                                children: areaData.counties().map((county)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                        value: county,
                                                                        children: county
                                                                    }, county))
                                                            })
                                                        ]
                                                    }),
                                                    !isLarge ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                        position: "relative",
                                                        sx: {
                                                            padding: "6px 22px 6px 22px"
                                                        },
                                                        onClick: handleOpenModal,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                            position: "relative",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                    width: 24,
                                                                    height: 24,
                                                                    alt: "",
                                                                    src: "/img/filter.svg",
                                                                    style: {
                                                                        display: "block"
                                                                    }
                                                                }),
                                                                (filterState === null || filterState === void 0 ? void 0 : filterState.name) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                                    width: 8,
                                                                    height: 8,
                                                                    borderRadius: "50%",
                                                                    bgcolor: "red",
                                                                    position: "absolute",
                                                                    top: -9,
                                                                    right: -9
                                                                })
                                                            ]
                                                        })
                                                    }) : null
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* HideInDesktopGrid */.D2, {
                                            item: true,
                                            xs: 12,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VenderList_AdvancedFilterSelection, {
                                                registerOpenModal: (fn)=>openModal = fn,
                                                serviceClassification: filterState.serviceItem,
                                                advancedFilterItems: filterState.advancedFilterItems,
                                                state: filterState,
                                                isLarge: isLarge,
                                                dispatch: filterDispatch
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentWrapper/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(GutterGrid/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* HideInMobileGrid */.W, {
                                    item: true,
                                    xs: 12,
                                    lg: 3,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Sticky, {
                                        topOffset: height,
                                        isSticky: isSticky,
                                        isVisible: isVisible,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicAdvanceFilters, {
                                            serviceClassificationName: filterState === null || filterState === void 0 ? void 0 : filterState.name,
                                            serviceClassification: filterState.serviceItem,
                                            advancedFilterItems: filterState.advancedFilterItems,
                                            fallbackData: fallbackData,
                                            isLarge: isLarge,
                                            isVisible: isVisible,
                                            onRemoveFilteredName: onRemoveFilteredName,
                                            dispatch: filterDispatch
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                    item: true,
                                    xs: 12,
                                    lg: 9,
                                    mb: 6,
                                    children: [
                                        (!!((_filterState_advancedFilterItems = filterState.advancedFilterItems) === null || _filterState_advancedFilterItems === void 0 ? void 0 : _filterState_advancedFilterItems.length) || (0,isString/* default */.Z)(filterState.name)) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                            mb: 6,
                                            mt: 4,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                                container: true,
                                                spacing: 2,
                                                alignItems: "center",
                                                sx: {
                                                    overflowX: "scroll",
                                                    scrollbarWidth: "none",
                                                    scrollBehavior: "smooth"
                                                },
                                                children: [
                                                    (0,isString/* default */.Z)(filterState.name) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                                        item: true,
                                                        maxWidth: "100%",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                                display: "flex",
                                                                flexWrap: "noWrap",
                                                                alignItems: "center",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                                        variant: "bodySmall",
                                                                        sx: {
                                                                            ...!isMobile ? {
                                                                                display: "block",
                                                                                WebkitBoxOrient: "vertical",
                                                                                overflow: "hidden",
                                                                                textOverflow: "ellipsis",
                                                                                WebkitLineClamp: 1,
                                                                                whiteSpace: "nowrap"
                                                                            } : {
                                                                                whiteSpace: "nowrap"
                                                                            }
                                                                        },
                                                                        children: [
                                                                            "廠商關鍵字：",
                                                                            filterState.name
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                                        display: "flex",
                                                                        onClick: onRemoveFilteredName,
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* CloseSVG */.b, {
                                                                            $ptr: true,
                                                                            width: 20,
                                                                            height: 20
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    }),
                                                    (_filterState_advancedFilterItems1 = filterState.advancedFilterItems) === null || _filterState_advancedFilterItems1 === void 0 ? void 0 : _filterState_advancedFilterItems1.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                                            item: true,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag, {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                                    display: "flex",
                                                                    flexWrap: "noWrap",
                                                                    alignItems: "center",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                            variant: "caption",
                                                                            children: filterItemMap.get(item)
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                                            display: "flex",
                                                                            onClick: ()=>onRemoveAdvancedFilterItem(item),
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* CloseSVG */.b, {
                                                                                $ptr: true,
                                                                                width: 12,
                                                                                height: 12
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        }, item))
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                            display: "flex",
                                            justifyContent: "end",
                                            alignItems: "center",
                                            mb: isLarge ? 6 : 4,
                                            mt: 6,
                                            children: isLarge && !!(venders === null || venders === void 0 ? void 0 : venders.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                ml: isLarge ? 12 : 0,
                                                minWidth: "fit-content",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination/* default */.Z, {
                                                    page: page,
                                                    setPage: setPage,
                                                    pageAmount: Math.ceil(venderCount / NUMBER_PER_PAGE),
                                                    urlPath: constants/* LS_APP_DOMAIN */._8 + "/vender"
                                                })
                                            })
                                        }),
                                        (supportServiceData === null || supportServiceData === void 0 ? void 0 : supportServiceData.isSupport) && /*#__PURE__*/ (0,jsx_runtime.jsx)(A/* default */.Z, {
                                            href: "/service/".concat(serviceClassification === null || serviceClassification === void 0 ? void 0 : serviceClassification.identityCode),
                                            onClick: ()=>{
                                                GtmAgent/* GtmAgent.directSendToGTM */.b.directSendToGTM({
                                                    event: "living_action",
                                                    living_event_name: "find_supplier_click",
                                                    ...(filterState === null || filterState === void 0 ? void 0 : filterState.serviceCounty) && {
                                                        living_filter_county: filterState.serviceCounty
                                                    },
                                                    ...(filterState === null || filterState === void 0 ? void 0 : filterState.serviceClassificationName) && {
                                                        living_filter_service: filterState.serviceClassificationName
                                                    },
                                                    ...(filterState === null || filterState === void 0 ? void 0 : filterState.name) && {
                                                        living_search_keyword: filterState.name
                                                    }
                                                });
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                                backgroundColor: "primary.bgPlus2",
                                                border: 1,
                                                borderColor: "primary.minus2",
                                                borderRadius: 1.5,
                                                gap: 2,
                                                p: 5,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        variant: "paraBodySmall",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        color: "text.minus2",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(NowrapDiv/* default */.Z, {
                                                            $lines: 3,
                                                            children: [
                                                                "不知道找哪間廠商？讓信義居家幫您找廠商，點擊前往",
                                                                " ",
                                                                filterState.serviceClassificationName,
                                                                " 預約"
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                        width: 24,
                                                        height: 24,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRight/* ArrowRight */.o, {
                                                            color: "primary.main"
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        !isVendersLoading && !(venders === null || venders === void 0 ? void 0 : venders.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                            my: 25,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(VenderList_Img, {
                                                    src: "/img/default-search-off.svg"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                    mt: 5,
                                                    mb: 3,
                                                    textAlign: "center",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                            variant: "h6",
                                                            children: "找不到合適的廠商嗎？"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                            color: "textSecondary",
                                                            mt: 3,
                                                            mb: 3,
                                                            children: "請服務人員幫你找吧～"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        !isVendersLoading && !!(venders === null || venders === void 0 ? void 0 : venders.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* default */.Z, {
                                            dataLength: (venders === null || venders === void 0 ? void 0 : venders.length) || 0,
                                            hasMore: true,
                                            next: onLoadMore,
                                            scrollThreshold: 0.3,
                                            scrollableTarget: containerId,
                                            children: venders === null || venders === void 0 ? void 0 : venders.map((vender)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.ZP, {
                                                    height: 80,
                                                    scrollContainer: "#".concat(containerId),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VenderList_VenderListItem, {
                                                        vender: vender,
                                                        onAlbumClick: onAlbumClick,
                                                        isLarge: isLarge,
                                                        filterState: filterState
                                                    })
                                                }, vender._id))
                                        }),
                                        isLarge && !!(venders === null || venders === void 0 ? void 0 : venders.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                            display: "flex",
                                            justifyContent: "center",
                                            mt: 6,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination/* default */.Z, {
                                                page: page,
                                                setPage: setPage,
                                                pageAmount: Math.ceil(venderCount / NUMBER_PER_PAGE)
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                            variant: "paraBodySmall",
                                            color: "text.secondary",
                                            mt: 16,
                                            children: [
                                                "*",
                                                Vender_constants/* VENDER_AD_WARNING_TEXT */.r
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    (webview === null || webview === void 0 ? void 0 : webview.name) !== "lsApp" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer["default"], {})
                ]
            }),
            (router === null || router === void 0 ? void 0 : router.isReady) && albumModal.open && /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* FullscreenModal */.OW, {
                open: albumModal.open,
                onClose: closeAlbumModal,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicAlbumContent, {
                    onClose: onAlbumContentClose,
                    closeModal: closeAlbumModal,
                    fallbackData: albumModal.fallbackData
                })
            })
        ]
    });
};
VenderList.defaultProps = {
    isMobile: true
};
/* harmony default export */ var Vender_VenderList = (VenderList);

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/lodash-es/isEmpty.js
var isEmpty = __webpack_require__(79697);
;// CONCATENATED MODULE: ./components/pages/Vender/VenderList/MetaTags.js





const genTitle = (serviceCounty, district, serviceClassificationFilter)=>{
    let title = "尋找";
    if (serviceCounty) {
        title += "在".concat(serviceCounty).concat(district || "");
    }
    title += "可提供".concat((serviceClassificationFilter === null || serviceClassificationFilter === void 0 ? void 0 : serviceClassificationFilter.name) || "居住生活相關", "服務的廠商 - 信義居家");
    return title;
};
const genDesc = (serviceCounty, district, serviceClassificationFilter)=>{
    let desc = "";
    if (serviceCounty) {
        desc += "這是在".concat(serviceCounty).concat(district || "");
    }
    desc += "可提供".concat((serviceClassificationFilter === null || serviceClassificationFilter === void 0 ? void 0 : serviceClassificationFilter.name) || "居家相關", "服務的廠商，經過信義居家嚴格品選出的優質合作夥伴，要給你一個溫馨舒適的家，需要").concat((serviceClassificationFilter === null || serviceClassificationFilter === void 0 ? void 0 : serviceClassificationFilter.name) || "居住生活相關", "服務，請務必交給我們為您服務。");
    return desc;
};
const MetaTags = (param)=>{
    let { resolvedUrl , serviceCounty , district , serviceClassificationFilter , searchText , page  } = param;
    const pathName = resolvedUrl.split("?")[0];
    const isSearchPage = /search/.test(pathName);
    const originUrl = "".concat(constants/* LS_APP_DOMAIN */._8 + pathName);
    const qs = {
        page: 1
    };
    if (isSearchPage) {
        qs.keyword = searchText;
    }
    if (serviceCounty) {
        qs.serviceCounty = serviceCounty;
        if (district) {
            qs.district = district;
        }
    }
    if (serviceClassificationFilter) {
        qs.serviceItem = serviceClassificationFilter._id;
    }
    let path = isSearchPage ? "".concat(originUrl, "/search") : originUrl;
    if (!(0,isEmpty/* default */.Z)(qs)) {
        path += "?".concat((0,qs_lib.stringify)(qs));
    }
    const title = genTitle(serviceCounty, district, serviceClassificationFilter);
    const description = genDesc(serviceCounty, district, serviceClassificationFilter);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
        children: [
            !!title && /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: title
            }),
            !!description && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "description",
                content: description
            }, "description"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "title",
                content: title
            }, "title"),
            !!description && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "description",
                content: description
            }, "description"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:title",
                content: title
            }, "og:title"),
            !!description && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:description",
                content: description
            }, "og:description"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "canonical",
                href: path
            }, "canonical"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:url",
                content: path
            }, "og:url")
        ]
    });
};
/* harmony default export */ var VenderList_MetaTags = (MetaTags);

// EXTERNAL MODULE: ./components/common/NoindexRemoval/index.js
var NoindexRemoval = __webpack_require__(84070);
;// CONCATENATED MODULE: ./utils/api/general/getVenders.js


const getVenders = (props)=>{
    return (0,request/* safeAwait */.Ev)((0,request/* lsGet */.UY)("/venders?".concat((0,qs_lib.stringify)({
        ...props,
        isFilterListVisible: true
    }))));
};

;// CONCATENATED MODULE: ./utils/api/general/getVenderCount.js


const getVenderCount = (props)=>{
    return (0,request/* safeAwait */.Ev)((0,request/* lsGet */.UY)("/venders/count?".concat((0,qs_lib.stringify)({
        ...props,
        isFilterListVisible: true
    }))));
};

// EXTERNAL MODULE: ./utils/helpers/index.js
var helpers = __webpack_require__(30905);
;// CONCATENATED MODULE: ./pages/vender/index.js









const VenderListPage = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NoindexRemoval/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Vender_VenderList, {
                ...props
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VenderList_MetaTags, {
                resolvedUrl: props.resolvedUrl,
                serviceCounty: props.fallbackData.serviceCounty,
                district: props.fallbackData.district,
                serviceClassificationFilter: props.fallbackData.serviceClassificationFilter,
                searchText: props.fallbackData.searchText,
                page: props.fallbackData.page
            })
        ]
    });
};
var __N_SSP = true;
const getServerSidePropsFunction = async (context)=>{
    var _context_query, _context_query1, _context_query2, _context_query3, _context_query4;
    const ua = ua_parser_default()(context.req.headers["user-agent"]);
    const isMobile = (0,includes/* default */.Z)([
        "mobile",
        "tablet"
    ], ua.device.type);
    const page = isMobile ? 1 : parseInt((_context_query = context.query) === null || _context_query === void 0 ? void 0 : _context_query.page) || 1;
    // serviceItem is one specific serviceClassificationId
    const serviceItem = ((_context_query1 = context.query) === null || _context_query1 === void 0 ? void 0 : _context_query1.serviceItem) || "";
    const serviceCounty = decodeURIComponent(((_context_query2 = context.query) === null || _context_query2 === void 0 ? void 0 : _context_query2.serviceCounty) || "");
    const district = decodeURIComponent(((_context_query3 = context.query) === null || _context_query3 === void 0 ? void 0 : _context_query3.district) || "");
    const searchText = (0,helpers/* safeDecodeURIComponent */.eC)((_context_query4 = context.query) === null || _context_query4 === void 0 ? void 0 : _context_query4.keyword);
    const limit = NUMBER_PER_PAGE;
    const skip = isMobile ? 0 : (0,max/* default */.Z)([
        page - 1,
        0
    ]) * NUMBER_PER_PAGE;
    const vendersQuery = (0,cond/* default */.Z)([
        [
            (param)=>{
                let { search  } = param;
                return !!search;
            },
            (param)=>{
                let { search  } = param;
                return {
                    search,
                    limit,
                    skip
                };
            }
        ],
        [
            ()=>true,
            ()=>({
                    limit,
                    skip
                })
        ]
    ])({
        search: searchText
    });
    const vendersPromise = getVenders(vendersQuery);
    const { limit: venderLimit , ...venderCountQuery } = vendersQuery;
    const venderCountPromise = !isMobile && searchText ? getVenderCount(venderCountQuery) : Promise.resolve([
        null
    ]);
    const [vendersResult, venderCountResult] = await Promise.all([
        vendersPromise,
        venderCountPromise
    ]);
    const [venders, vendersError] = vendersResult;
    const [venderCount, vendersCountError] = venderCountResult;
    const [serviceClassification] = serviceItem ? await (0,getServiceClassificationById/* getServiceClassificationById */.J)(serviceItem) : [];
    return {
        props: {
            isMobile,
            fallbackData: {
                page,
                searchText,
                serviceItem,
                serviceCounty,
                district,
                // fetched data
                venders: venders !== undefined ? venders : null,
                venderCount,
                serviceClassificationFilter: serviceClassification || null
            },
            resolvedUrl: context.resolvedUrl
        }
    };
};
/* harmony default export */ var vender = ((0,withLivingSinyi/* default */.Z)(VenderListPage));


/***/ }),

/***/ 84104:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ getServiceClassificationById; }
/* harmony export */ });
/* harmony import */ var utils_request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72673);

const getServiceClassificationById = (id)=>{
    return (0,utils_request__WEBPACK_IMPORTED_MODULE_0__/* .safeAwait */ .Ev)((0,utils_request__WEBPACK_IMPORTED_MODULE_0__/* .lsGet */ .UY)("/serviceClassifications/".concat(id)));
};


/***/ }),

/***/ 3491:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ setVenderViewedOrClicked; }
/* harmony export */ });
/* harmony import */ var utils_request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72673);

const setVenderViewedOrClicked = (venderId, params)=>{
    return (0,utils_request__WEBPACK_IMPORTED_MODULE_0__/* .safeAwait */ .Ev)((0,utils_request__WEBPACK_IMPORTED_MODULE_0__/* .lsPut */ .OL)("/venders/".concat(venderId, "/clicksOrViews"), params));
};


/***/ }),

/***/ 56724:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ useVenderSupportItems; }
/* harmony export */ });
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var utils_hooks_fetchers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86700);
/* harmony import */ var utils_request__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72673);



const useVenderSupportItems = (dataSource, swrOptions)=>{
    const genUrl = ()=>{
        try {
            const props = typeof dataSource === "function" ? dataSource() : dataSource;
            if (props === null) {
                return null;
            }
            return [
                "/venders/supportServices?".concat((0,qs__WEBPACK_IMPORTED_MODULE_0__.stringify)(props)),
                utils_request__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getToken */ .ZP.getToken()
            ];
        } catch (err) {
            return null;
        }
    };
    return (0,utils_hooks_fetchers__WEBPACK_IMPORTED_MODULE_1__/* .useCustomSWR */ .LW)(genUrl, utils_request__WEBPACK_IMPORTED_MODULE_2__/* .lsGet */ .UY, swrOptions);
};


/***/ }),

/***/ 75082:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ getVenderJoinedYears; }
/* harmony export */ });
const getVenderJoinedYears = (dateStr)=>{
    if (!dateStr) return 0;
    const joinedDate = new Date(dateStr);
    if (isNaN(joinedDate.getTime())) return 0;
    const now = new Date();
    let years = now.getFullYear() - joinedDate.getFullYear();
    const monthDiff = now.getMonth() - joinedDate.getMonth();
    if (monthDiff < 0 || monthDiff === 0 && now.getDate() < joinedDate.getDate()) {
        years--;
    }
    return Math.max(0, years);
};


/***/ }),

/***/ 19575:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ getVenderWelcomeInfo; }
/* harmony export */ });
const getText = (value)=>{
    if (typeof value === "string") return value;
    return (value === null || value === void 0 ? void 0 : value.text) || "";
};
const getVenderWelcomeInfo = (vender)=>{
    var _welcomeInfoSetting_logo;
    const welcomeInfoSetting = (vender === null || vender === void 0 ? void 0 : vender.welcomeInfoSetting) || {};
    const typicalImages = (welcomeInfoSetting === null || welcomeInfoSetting === void 0 ? void 0 : welcomeInfoSetting.typicalImages) || {};
    return {
        logoImage: (welcomeInfoSetting === null || welcomeInfoSetting === void 0 ? void 0 : (_welcomeInfoSetting_logo = welcomeInfoSetting.logo) === null || _welcomeInfoSetting_logo === void 0 ? void 0 : _welcomeInfoSetting_logo.image) || null,
        typicalImage: (typicalImages === null || typicalImages === void 0 ? void 0 : typicalImages.typicalImage) || null,
        typicalMobileImage: (typicalImages === null || typicalImages === void 0 ? void 0 : typicalImages.typicalMobileImage) || null,
        announcementText: getText(welcomeInfoSetting === null || welcomeInfoSetting === void 0 ? void 0 : welcomeInfoSetting.announcement),
        favorableDiscountText: getText(welcomeInfoSetting === null || welcomeInfoSetting === void 0 ? void 0 : welcomeInfoSetting.favorableDiscount),
        brieflyDescribeText: getText(welcomeInfoSetting === null || welcomeInfoSetting === void 0 ? void 0 : welcomeInfoSetting.brieflyDescribe)
    };
};


/***/ })

}]);